import { render, staticRenderFns } from "./rd.vue?vue&type=template&id=45b027cf&"
import script from "./rd.vue?vue&type=script&lang=js&"
export * from "./rd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports